module.exports = __webpack_public_path__ + "img/Google.652d53f9.png";